import React from 'react';
import { Box, Inscription, SearchInput } from '@common-fe/common-fe';

interface Props {
  searchString: string;
  setSearchString: (searchString: string) => void;
}

const EligibleServicesAiSearch: React.FC<Props> = ({ searchString, setSearchString }) => {
  return (
    <Box
      data-testid="EligibleServicesAiSearch-container"
      pad="spacing24"
      round="container1Round"
      background="canvas"
      border={{ size: 'small', color: 'border1' }}
    >
      <Inscription
        weight="bold"
        lineHeight="20px"
      >
        Forgot the name? Just describe it.
      </Inscription>
      <Box margin={{ top: 'spacing8' }}>
        <SearchInput
          autoFocus
          testId="EligibleServicesAiSearch"
          onChange={setSearchString}
          value={searchString}
          placeholder="Describe the expense you had (e.g., braces)"
          aiSearchMode
          hideTip
        />
      </Box>
    </Box>
  );
};

export default EligibleServicesAiSearch;
